import { shuffle } from 'lodash-es'
import trim from 'lodash-es/trim'
import { TeamRole } from './@types/statamic'
import { Mandatory } from './@types/util'
import { ExternalReview, Website } from '@/src/@types/blinkadmin'
import { fetchWithRetry } from '@/src/lib/fetchWithRetry'

const API_ADMIN_URL = process.env.NEXT_PUBLIC_BLINK_ADMIN_URL

export async function get<Response = unknown>(
  url: string,
  params?: Record<string, string>
): Promise<Response> {
  url = trim(url, '/')

  if (params) {
    url += '?' + new URLSearchParams(params).toString()
  }

  const res = await fetchWithRetry(`${API_ADMIN_URL}/${url}`)

  return await res.json()
}

export async function getTeamMembers(
  roles: TeamRole[] = [],
  locations: string[] = []
): Promise<Mandatory<Website.TeamMember, 'image'>[]> {
  const members = await get<Website.TeamMember[]>(
    `api/website/v2/team-members?filter[roles]=${roles.join(',')}&filter[locations]=${locations.join(',')}`
  )
  return shuffle(
    members.filter(
      (member): member is Mandatory<Website.TeamMember, 'image'> =>
        !!member.image
    )
  )
}

export async function getSpecificTeamMembers(
  teamMemberIds: string[]
): Promise<Mandatory<Website.TeamMember, 'image'>[]> {
  const members = await get<Website.TeamMember[]>(
    `api/website/v2/team-members?filter[members]=${teamMemberIds.join(',')}`
  )

  return members.filter(
    (member): member is Mandatory<Website.TeamMember, 'image'> => !!member.image
  )
}

export type ExternalReviewType =
  | 'vku'
  | 'firstaid'
  | 'firstaid-nohe'
  | 'car-lessons'
  | 'bike-lessons'
  | 'trailer-lessons'
  | 'theory-app'

export async function getExternalReviews(
  types: ExternalReviewType[] = [],
  locations: string[] = []
): Promise<ExternalReview[]> {
  const reviews = await get<ExternalReview[]>(
    `api/website/v2/external-reviews?filter[tags]=${types.join(',')}&filter[locations]=${locations.join(',')}`
  )
  return reviews.sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
  )
}
